import { Offcanvas } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import NewTaskFormik from './NewTaskFormik';
import type { NewTaskDefaultDue } from './helpers/initNewTaskStruct';

export type { NewTaskDefaultDue };

export interface NewTaskProps {
    show: boolean;
    onHide: () => void;
    onCreated?: () => void;
    leadId?: number | null;
    objectId?: number | null;
    contextName?: string | null;
    defaultDue?: NewTaskDefaultDue | null;
}

const NewTask = ({
    show,
    onHide,
    onCreated,
    leadId = null,
    objectId = null,
    contextName = null,
    defaultDue = null,
}: NewTaskProps) => {
    const { t } = useTranslation(['Tasks']);

    return (
        <Offcanvas
            show={show}
            onHide={onHide}
            placement="end"
            backdrop
            backdropClassName="new-task-offcanvas-backdrop"
            className="new-task-offcanvas notranslate"
            translate="no"
        >
            <Offcanvas.Header closeButton className="border-bottom">
                <Offcanvas.Title>{t('titleNew')}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body
                className="position-relative pb-0 d-flex flex-column px-0"
                data-lead-id={leadId ?? undefined}
                data-object-id={objectId ?? undefined}
            >
                <NewTaskFormik
                    show={show}
                    onHide={onHide}
                    onCreated={onCreated}
                    leadId={leadId}
                    objectId={objectId}
                    contextName={contextName}
                    defaultDue={defaultDue}
                />
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default NewTask;
